<template>
    <div class="cal__footer" v-on:click="openModal">
        <a class="cal__footer_link">
            <span class="cal__footer_title cal__font_bree">Recevoir au format Excel</span>
        </a>
    </div>
</template>


<script>
export default {
  name: 'AppFooterMobile',
  methods: {
    openModal: function(){
       this.$store.commit('SHOW_MODAL', { type: 'email' })
    }
  }
}
</script>

